import BambooFluentIcon from '@Src/commons/BambooFluentIcon';
import COLOR from '@Src/commons/Colors';
import { NormalText, NumericText } from '@Src/commons/StyledComponent';
import { Nullable } from '@Src/commons/Ticketing/types';
import { CheckCircleFilled } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import React from 'react';

type ProductCardPropTypes = {
  item: {
    itemName: string;
    itemDescription: string | null;
    quantity: number;
    unit: string;
    productTotalAmount: string | number;
  };
  isLastProduct?: boolean;
};

export default function ProductCard({
  item,
  isLastProduct,
}: ProductCardPropTypes) {
  return (
    <div
      className={`${
        isLastProduct ? '' : 'product-card'
      } pr-16 pl-16 pt-12 pb-12`}
    >
      <Row justify="space-between">
        <Col span={12}>
          <Row>
            {' '}
            <NormalText color={COLOR.GRAY_11} fontSize={16} fontWeight={600}>
              {item.itemName}
            </NormalText>
          </Row>
          <Row>
            {' '}
            <NormalText color={COLOR.GRAY_12} fontSize={12} fontWeight={600}>
              {item.itemDescription}
            </NormalText>
          </Row>
        </Col>
        <Col>
          <Row>
            {' '}
            <NormalText color={COLOR.GRAY_11} fontSize={16} fontWeight={600}>
              {item.quantity} {item.unit}
            </NormalText>
          </Row>
          <Row>
            {' '}
            <NumericText color={COLOR.GRAY_12} fontSize={12} fontWeight={600}>
              INR {item.productTotalAmount}
            </NumericText>
          </Row>
        </Col>
      </Row>
      <Row className="mt-8">
        <Input
          type="number"
          defaultValue={item.quantity}
          disabled
          addonAfter={item.unit}
          suffix={
            <BambooFluentIcon
              icon={<CheckCircleFilled style={{ color: COLOR.GREEN }} />}
            />
          }
        />
      </Row>
    </div>
  );
}
